import { Body } from 'matter-js';

export const DOT_CATEGORY = Body.nextCategory();
export const PLAYER_CATEGORY = Body.nextCategory();
export const GHOST_CATEGORY = Body.nextCategory();
export const WALL_CATEGORY = Body.nextCategory();
